import { useEffect } from "react";
import { useQuery, useSubscription } from "@apollo/react-hooks";
import {
  MY_TAX_DECLARATIONS_SUBSCRIPTION,
  MY_TAX_GET_DECLARATIONS_LIST,
} from "my-tax/graphql";
import useTaxApplications from "my-tax/hooks/use-tax-applications";

interface TableData {
  page: number;
  pageSize: number;
}

export const useTaxDeclarationList = ({
  tableData,
  type,
}: {
  tableData: TableData;
  type: string;
}) => {
  const { taxApplications, setTaxApplications, resetTaxApplications } =
    useTaxApplications();

  const { data, loading, error, refetch } = useQuery(
    MY_TAX_GET_DECLARATIONS_LIST,
    {
      fetchPolicy: "cache-and-network",
      variables: {
        page: tableData.page,
        pageSize: tableData.pageSize,
        type,
      },
    },
  );

  const { data: allData, refetch: allRefetch } = useQuery(
    MY_TAX_GET_DECLARATIONS_LIST,
    {
      fetchPolicy: "cache-and-network",
      variables: {
        page: 1,
        pageSize: 200,
        type: "all",
      },
    },
  );

  useEffect(() => {
    if (allData) {
      resetTaxApplications();
    }
  }, [allData, resetTaxApplications]);

  const allRequests: Array<{ year: string; state: string; type: string }> =
    allData?.taxDeclarationList?.rows || [];
  const currentYear = new Date().getFullYear().toString();

  useEffect(() => {
    if (allRequests.length > 0) {
      allRequests.forEach((req) => {
        if (
          req?.year === currentYear &&
          (req?.state === "K" || req?.state === "E") &&
          taxApplications[req?.type] === true
        ) {
          const newState = { ...taxApplications, [req?.type]: false };
          setTaxApplications(newState);
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allRequests, taxApplications, setTaxApplications]);

  useSubscription(MY_TAX_DECLARATIONS_SUBSCRIPTION, {
    skip: !data,
    onData: () => {
      resetTaxApplications();
      refetch();
      allRefetch();
    },
  });

  const result = data?.taxDeclarationList || {
    rows: [],
    total: 0,
    page: 1,
    pageSize: tableData.pageSize,
    totalPages: 0,
  };

  return { data: result, loading, error, refetch };
};

export default useTaxDeclarationList;
